import { LEGAL_SECTIONS, NOT_FOR_NAVIGATION } from '../core/legal';

export interface DisclaimerGateProps {
  onAccept: () => void;
}

/**
 * First-run disclaimer, which must be acknowledged before the chart appears.
 *
 * Blocking, deliberately. Everywhere else this app prefers to stay out of the
 * way, but the one thing a skipper must not discover halfway through a passage
 * is that the depths carry no tide correction and the bearings carry no
 * variation. Showing it once, up front, is the only moment it can be read
 * without something more urgent competing for attention.
 *
 * It is shown *instead of* the chart rather than over it: an overlay invites
 * dismissal by tapping past it, and on a phone that is one thumb away from
 * never having been read at all.
 */
export function DisclaimerGate({ onAccept }: DisclaimerGateProps): React.JSX.Element {
  return (
    <div className="disclaimer" role="dialog" aria-modal="true" aria-labelledby="disclaimer-title">
      <div className="disclaimer__inner">
        <h1 id="disclaimer-title" className="disclaimer__title">
          {NOT_FOR_NAVIGATION}
        </h1>
        <p className="disclaimer__lede">
          Read this before you rely on anything here. It is short because all of
          it matters.
        </p>

        <div className="disclaimer__body">
          {LEGAL_SECTIONS.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 40)}>{paragraph}</p>
              ))}
            </section>
          ))}
        </div>

        <button type="button" className="disclaimer__accept" onClick={onAccept}>
          I understand — carry official charts
        </button>
        <p className="disclaimer__footer">
          This text stays available in Settings → Legal.
        </p>
      </div>
    </div>
  );
}
